<template>
    <div>
        <div class="w-full flex flex-col">
            <div class="modal-header flex items-center justify-between cursor-move">
                <h1 class="flex-1 text-2xl">Manage Subsidiaries</h1>
                <div @click="hideModal">
                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
                </div>
            </div>
            <div class="w-full flex">
                <div class="modal-toolbar flex items-center justify-between">
                    <div class="flex items-center">
                        <div v-if="subsidiaries.all.length" class="flex items-center">
                            <div>
                                <label for="subsidiary_id" class="pt-0">Subsidiary</label>
                                <select v-model="selectedSubsidiaryId" name="subsidiary_id" class="form-select form-select-blue">
                                    <option value="">Select Subsidiary</option>
                                    <option v-for="subsidiary in subsidiaries.all" :key="subsidiary.id" :value="subsidiary.id">{{ subsidiary.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button @click.prevent="createSubsidiary" class="flex items-center btn btn-small btn-indigo">
                            <inline-svg name="add" classes="w-4 h-4 text-white fill-current"></inline-svg>
                            <span class="ml-2">Create Subsidiary</span>
                        </button>
                    </div>                             
                </div>
            </div>
        </div>

        <div class="flex">
            <div class="modal-sidebar">
                <ul>
                    <li @click="section = 'subsidiary-info'">
                        <span :class="{ highlighted: section == 'subsidiary-info' }">Subsidiary Info</span>
                    </li>
                </ul>
            </div>

            <div class="w-full h-full" style="min-height: 600px;">
                <div v-show="section == 'subsidiary-info'" class="w-full h-full">
                    <div v-if="! subsidiaries.all.length" class="flex flex-col items-center justify-center my-10">
                        <span class="none-found">No Subsidiaries Found</span>
                    </div>
                    <div v-else-if="subsidiaries.all && ! selectedSubsidiaryId" class="text-center my-10">
                        <span class="text-xl">Select a Subsidiary</span>
                    </div>
                    <div v-else>
			            <div class="w-full flex flex-col">
					        <div class="modal-small-toolbar">
					            <span>Subsidiary Information</span>
					        </div>
			                <div class="w-full max-w-lg flex p-4">
			                    <div class="flex flex-1 flex-col p-3">
			                        <div class="flex flex-col mb-4">
			                            <div class="flex-1 mb-6">
			                                <label class="block text-sm mb-2" for="name">Name</label>
			                                <input type="text" name="name" class="form-input w-full" v-model="subsidiaries.selectedSubsidiary.name">
			                                <div v-if="errors.name" class="form-error">{{ errors.name[0] }}</div>
			                            </div>

			                            <div class="bg-gray-100">
			                                <div class="flex flex-col shadow-md rounded border border-gray-300 p-4">
			                                    <div class="mb-5 flex flex-col flex-grow">
			                                        <label class="block text-sm mb-2" for="country">Country</label>
			                                        <select v-model="subsidiaries.selectedSubsidiary.country_id" class="mt-0 form-select">
			                                            <option value=""></option>
			                                            <option v-for="country in countries" :key="country.id" :value="country.id">{{ country.name }}</option>
			                                        </select>
			                                        <div v-if="errors.country_id" class="form-error">{{ errors.country_id[0] }}</div>
			                                    </div>
			                                    <div class="mb-5">
			                                        <label class="block text-sm mb-2" for="address">Address</label>
			                                        <input v-model="subsidiaries.selectedSubsidiary.address" type="text" class="form-input w-full">
			                                        <div v-if="errors.address" class="form-error">{{ errors.address[0] }}</div>
			                                    </div>

			                                    <div class="flex mb-5">
			                                        <div class="mr-4">
			                                            <label class="block text-sm mb-2" for="city">City</label>
			                                            <input v-model="subsidiaries.selectedSubsidiary.city" type="text" class="form-input">
			                                            <div v-if="errors.city" class="form-error">{{ errors.city[0] }}</div>
			                                        </div>
			                                        <div v-if="subsidiaries.selectedSubsidiary.country_id == 16" class="mr-4">
			                                            <label class="block text-sm mb-2" for="state">State</label>
			                                            <select v-model="subsidiaries.selectedSubsidiary.state" class="w-20 form-select min-w-fit">
			                                                <option value=""></option>
			                                                <option v-for="(state, stateIndex) in states" :key="stateIndex" :value="state.state">{{ state.state }}</option>
			                                            </select>
			                                            <div v-if="errors.state" class="form-error">{{ errors.state[0] }}</div>
			                                        </div>
			                                        <div>
			                                            <label class="block text-sm mb-2" for="postal_code">Postal Code</label>
			                                            <input v-model="subsidiaries.selectedSubsidiary.postal_code" type="text" class="form-input">
			                                            <div v-if="errors.postal_code" class="form-error">{{ errors.postal_code[0] }}</div>
			                                        </div>
			                                    </div>
			                                </div>
			                            </div>
			                        </div>
					                <div class="flex justify-between mt-4">
					                    <div class="space-x-3">
					                        <button 
					                            type="button"
					                            @click="confirmDeleteSubsidiary"
					                            class="btn btn-small btn-red">
					                                Delete Subsidiary
					                        </button>
					                    </div>

					                    <div>
					                    	<button type="button" class="btn btn-green" @click="save">
					        	                <span v-if="loading">
					        	                    <inline-svg name="loading-button"></inline-svg>                                
					        	                </span>
					        	                <span v-else>Save</span>
					        	            </button>
					                    </div>
					                </div>
			                    </div>
			                </div>
			            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
	        subsidiaryId: {
                type: Number,
                required: false,
            },

            selectedSection: {
                type: String,
                default: 'subsidiary-info'
            },

            forClientId: {
                type: Number,
                required: true
            },
        },

        data() {
            return {
            	section: this.selectedSection,
                selectedSubsidiaryId: this.subsidiaryId || '',
                clientId: this.forClientId,
                countries: {},
                states: {},
                loading: false,
                errors: {}
            }
        },

        created() {
            // pull requested subsidiary
            if (this.selectedSubsidiaryId) {
                this.subsidiaries.selectedSubsidiary = _.find(this.subsidiaries.all, ['id', this.selectedSubsidiaryId])
            }

            axios.get('/api/address-info').then((response) => {
                this.countries = response.data.countries;
                this.states = response.data.states;
            }).catch((error) => {
                console.log(error);
            });
        },

        watch: {
            selectedSubsidiaryId() {
                this.subsidiaries.selectedSubsidiary = _.find(this.subsidiaries.all, ['id', this.selectedSubsidiaryId]) || '';
            }
        },

        computed: {
            ...mapState(['subsidiaries'])
        },

        methods: {
            createSubsidiary() {
                this.subsidiaries.all.push({
                    id: 'new',
                    client_id: this.clientId,
                    country_id: 16
                });

                this.selectedSubsidiaryId = 'new';
            },

        	save() {
        		this.errors = '';
                this.loading = true;

        		let url = this.subsidiaries.selectedSubsidiary.id == 'new'
        			? '/subsidiaries'
        			: '/subsidiaries/' + this.subsidiaries.selectedSubsidiary.id;

                this.subsidiaries.selectedSubsidiary._method = this.subsidiaries.selectedSubsidiary.id == 'new'
                	? 'POST'
                	: 'PATCH';

                axios.post(url, this.subsidiaries.selectedSubsidiary).then(response => {
                    _.merge(this.subsidiaries.selectedSubsidiary, response.data.subsidiary);

                    this.selectedSubsidiaryId = response.data.subsidiary.id;

                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: response.data.message
                    });

                    this.$eventHub.$emit('reloadClient');
                }).catch(error => {
                    this.errors = error.response.data ? error.response.data.errors : '';
                }).finally(() => {
                    this.loading = false;
                })
        	},

            confirmDeleteSubsidiary() {
            	if (this.selectedSubsidiaryId == 'new') {
            		this.selectedSubsidiaryId = '';

            		this.subsidiaries.all = _.remove(this.subsidiaries.all, (subsidiary) => { return subsidiary.id != 'new' });

            		return;
            	}

                this.$swal({
                    title: 'Are you sure?',
                    text: "Are you sure you want to delete this subsidiary?",
                    type: 'warning',
                    buttonsStyling: false,
                    confirmButtonText: 'Yes - Delete it',
                    confirmButtonClass: 'btn btn-red',
                    showCancelButton: true,
                    cancelButtonClass: 'btn btn-secondary mr-4',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.deleteSubsidiary();
                    }
                });
            },

            deleteSubsidiary() {
                axios.delete('/subsidiaries/' + this.selectedSubsidiaryId)
                    .then(response => {
                        this.subsidiaries.all = _.remove(this.subsidiaries.all, (subsidiary) => { return subsidiary.id != this.selectedSubsidiaryId });
	                    
                         this.selectedSubsidiaryId = '';

	                    this.$notify({
	                        type: 'success',
	                        title: 'Success',
	                        text: response.data.message
	                    });

                        this.$eventHub.$emit('reloadClient');
                    })
                    .catch(error => {
                        console.log(error);
                        this.$notify({
                            type: 'error',
                            title: 'Error',
                            text: error.response.data.message
                        });
                    }
                );
            },
        }
    }
</script>